const SkeletonStyles = {
  baseStyle: {
    color: "gray.400",
  },
};

export default SkeletonStyles;
